import r2wc from "@r2wc/react-to-web-component";
import { SearchBarContainer } from "../components/SearchBarContainer";

const SearchBarWebComponent = r2wc(SearchBarContainer, {
  props: {
    apiKey: "string",
    apiBaseUrl: "string",
    fleetId: "string",
    theme: "string",
    layout: "string",
    placeholder: "string",
    primaryColor: "string",
    onSearch: "function",
    onChange: "function",
    initialData: "json",
    showVehicleSelector: "boolean",
    className: "string",
    disabled: "boolean",
  },
  events: {
    onSearch: { bubbles: true, composed: true },
    onChange: { bubbles: true, composed: true },
  },
});

if (!customElements.get("fm-search-bar")) {
  customElements.define("fm-search-bar", SearchBarWebComponent);
}
